<template>
  <div class="header-components">
    <div class="header-wrap">
      <el-row class="container header-top">
        <el-col :span="8">
          <div class="grid-content grid-content-left">
            <div class="domain">
              <div class="linkIri">
                官方域名：{{ easy_to_remember_domain_name }}
              </div>
            </div>
            <div class="time">
              <p class="lang">
                <img
                  v-for="item in international"
                  :key="item.src"
                  :src="item.src"
                  alt=""
                />
              </p>
              <p class="time-wrap">
                <span class="el-icon-time"></span>{{ nowTime | timeFilter }}
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content grid-content-middle">
            <router-link to="/">
              <img :src="logo" alt="" />
            </router-link>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content-right-wrap">
            <ul class="grid-content grid-content-right">
              <li ref="headerTopNav" v-for="item in navListUp" :key="item.name">
                <router-link
                  v-if="item.url && !item.requireAuth"
                  :to="item.url"
                  >{{ item.name }}</router-link
                >
                <a
                  v-if="item.src && !item.requireAuth"
                  :href="item.src"
                  target="_blank"
                  >{{ item.name }}</a
                >
                <a
                  v-if="item.requireAuth"
                  @click.prevent="toLogin(item)"
                  href="#"
                  >{{ item.name }}</a
                >
              </li>
              <li>
                <a target="_blank" :href="appDownload">APP下载</a>
              </li>
              <li ref="LKgame">
                <a @click.prevent="goLKgame" href="#">幸运棋牌</a>
              </li>
              <li>
                <a @click.prevent="lineNavigationList" href="#">备用网址</a>
              </li>
            </ul>
            <div v-if="discountList.length" class="swiper-list">
              <swiper style="height: 36px" :options="swiperOption">
                <swiper-slide
                  v-for="(item, index) in discountList"
                  :key="index"
                >
                  <router-link to="/discounts">
                    <div class="swiper-item">{{ item.articleName }}</div>
                  </router-link>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <main-nav v-if="!isAtSportsPage"></main-nav>
  </div>
</template>

<script>
/* eslint-disable*/
import MainNav from "../components/nav/main-nav";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState, mapActions } from "vuex";
import { common, commonApi, check, filter } from "@/common/index";
import { twinkle, twinkleTwo } from "../assets/js/dom";

export default {
  name: "headerNav",
  components: {
    MainNav,
    swiper,
    swiperSlide,
  },
  filters: {
    timeFilter(time) {
      return filter.getTimeYDMS(time);
    },
  },
  data() {
    return {
      // 时间
      nowTimer: "",
      nowTime: "",

      domain: require("../assets/images/headerNav/top/domain.gif"),
      license: require("../assets/images/headerNav/license.png"),
      logo: require("../assets/images/common/logo.png"),
      // 轮播
      swiperOption: {
        direction: "vertical",
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
      },
      navListUp: [
        {
          name: "手机投注",
          requireAuth: false,
          url: "",
          src:
            window.location.protocol +
            "//" +
            window.location.host.replace("www", "m"),
        },
        { name: "代理加盟", requireAuth: false, url: "/agency", src: "" },
        // {name: 'VIP俱乐部', requireAuth: false, url: '/privilege', src: ''},
        {
          name: "活动大厅",
          requireAuth: false,
          url: "/discountsHall",
          src: "",
        },
        // {
        //   name: "APP下载",
        //   requireAuth: false,
        //   url: "",
        //   src: "https://ieikba.com",
        // },
        {
          name: "快速充值",
          requireAuth: true,
          url: "/mine/capital/deposit",
          src: "",
        },
      ],

      international: [
        {
          src: require("../assets/images/headerNav/international/lang_cn.png"),
        },
        {
          src: require("../assets/images/headerNav/international/lang_tw.png"),
        },
        {
          src: require("../assets/images/headerNav/international/lang_en.png"),
        },
      ],
      // 备用网址
      Line_navigation: ["https://zqakey.com", "https://ttored.com"],
      // 优惠列表
      // discountList: []
    };
  },
  computed: {
    ...mapState({
      easy_to_remember_domain_name: (state) =>
        state.FrontConfigList.easy_to_remember_domain_name,
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      frontType: (state) => state.frontType,
      isAtSportsPage: (state) => state.isAtSportsPage,
      appDownload: (state) => state.linkList.appDownload,
      allBonusArticle: (state) => state.allBonusArticle,
    }),
    discountList() {
      return this.allBonusArticle.slice(0, 5);
    },
  },
  methods: {
    // 设置时间
    setNowTime() {
      this.nowTimer = setInterval(() => {
        this.nowTime = new Date().getTime();
      }, 1000);
    },
    // 提示登录
    toLogin(item) {
      if (this.isLogin) {
        this.$router.push({ path: item.url });
        return;
      }

      common.jinsha_GoGame(item.url, this.isLogin, this.UUID);
    },
    // 备用网址
    lineNavigationList() {
      let num = Math.round(Math.random() * 2);
      if (num == 2) {
        num = 1;
      }
      // console.log(num)
      let url = this.Line_navigation[num];
      window.open(url);
    },
    // 颜色闪烁
    twinkleColor() {
      let redGreen = [
        this.$refs.headerTopNav[1],
        this.$refs.headerTopNav[2],
        this.$refs.headerTopNav[4],
      ];
      let redYellow = [this.$refs.headerTopNav[4]];
      let lkgame = [this.$refs.LKgame];
      twinkle(redGreen);
      twinkleTwo(redYellow);
      twinkleTwo(lkgame);
    },
    ...mapActions(["checkLogin", "getFirstInfo"]),
    goLKgame() {
      this.$router.push({
        path: "/chess",
        query: {
          platformCode: "LUCKY",
        },
      });
    },
    // 获取优惠
    getDiscountList() {
      // let params = {
      //   offerTypes: -1 ,
      //   frontType:this.frontType,
      //   pageNo: 1,
      //   pageSize: 6,
      // };
      // commonApi.DISCOUNTS.offerList(params)
      //   .then(data => {
      //     this.discountList = data.list.slice(0,5)
      //   })
      //   .catch(err=>{
      //   })
      // this.discountList = this.allBonusArticle.slice(0,5)
    },
  },
  mounted() {
    this.setNowTime();
    // this.getDiscountList();

    this.$nextTick(() => {
      this.twinkleColor();
    });
    if (this.isLogin) {
      this.getFirstInfo();
    }
  },
  created() {
    this.checkLogin();
  },
};
</script>

<style scoped lang="scss">
@import "../style/variable";

.header-components {
  padding: 10px 0 0;
  background-color: #161616;
  .header-wrap {
    padding-bottom: 10px;
    border-bottom: 1px solid #303030;
    .header-top {
      color: #999;
      .grid-content-left {
        .linkIri {
          font-size: 20px;
          color: transparent;
          background: linear-gradient(to top, #c1b167, #faf8b9, #e0d790);
          -webkit-background-clip: text;
          font-weight: bold;
        }
        .time {
          padding: 15px 0;
          .lang {
            img {
              vertical-align: top;
            }
          }
          .time-wrap {
            margin-left: 10px;
            padding-left: 10px;
            position: relative;
            &:before {
              content: "";
              width: 1px;
              position: absolute;
              left: 0;
              height: 14px;
              top: 3px;
              background-color: rgba(153, 153, 153, 0.48);
            }
          }
          p {
            display: inline-block;
            height: 20px;
            line-height: 20px;
          }
        }
      }
      .grid-content-right {
        text-align: right;
        letter-spacing: -4px;
        & > :first-child {
          a {
            &:before {
              content: none;
            }
          }
        }
        & > :first-child {
          a {
            color: rgb(0, 255, 255);
          }
        }
        li {
          display: inline-block;
          letter-spacing: normal;
          a {
            color: #f2f2f2;
            display: inline-block;
            line-height: 25px;
            &:before {
              content: "|";
              display: inline-block;
              color: #80603e;
              padding: 0 6px;
            }
            &:hover {
              color: #f9e978;
            }
          }
        }
      }
      .swiper-list {
        margin-top: 4px;
        height: 36px;
        overflow: hidden;
        border: 1px solid #303030;
        border-radius: 20px;
        background: url("../assets/images/headerNav/top/icon02.png") no-repeat
          20px center;
        .swiper-item {
          color: #fff;
          height: 36px;
          line-height: 36px;
          padding-left: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/HeaderNav.vue